export default {
  popup: 10,
  notifications: 15,
  modal: 20,
  fullScreenLoader: 30,
} as const
